export type Maybe<Value> = Value | undefined | null;

export function isNil<T>(val: T | null | undefined): val is null | undefined {
	return val === undefined || val === null;
}

export function isNotNil<T>(val: T | null | undefined): val is T {
	return !isNil(val);
}

export function isNumber(val: unknown): val is number {
	return typeof val === 'number';
}

// eslint-disable-next-line @typescript-eslint/ban-types
export type HintedString<KnownValues extends string> = (string & {}) | KnownValues;
